var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/*! ut_metadata. MIT License. WebTorrent LLC <https://webtorrent.io/opensource> */
var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var bencode = require('bencode');

var BitField = require('bitfield').default;

var debug = require('debug')('ut_metadata');

var sha1 = require('simple-sha1');

var MAX_METADATA_SIZE = 1E7; // 10 MB

var BITFIELD_GROW = 1E3;
var PIECE_LENGTH = 1 << 14; // 16 KiB

module.exports = function (metadata) {
  var utMetadata = /*#__PURE__*/function (_EventEmitter) {
    "use strict";

    _inherits(utMetadata, _EventEmitter);

    var _super = _createSuper(utMetadata);

    function utMetadata(wire) {
      var _this;

      _classCallCheck(this, utMetadata);

      _this = _super.call(this);
      _this._wire = wire;
      _this._fetching = false;
      _this._metadataComplete = false;
      _this._metadataSize = null; // how many reject messages to tolerate before quitting

      _this._remainingRejects = null; // The largest torrent file that I know of is ~1-2MB, which is ~100
      // pieces. Therefore, cap the bitfield to 10x that (1000 pieces) so a
      // malicious peer can't make it grow to fill all memory.

      _this._bitfield = new BitField(0, {
        grow: BITFIELD_GROW
      });

      if (Buffer.isBuffer(metadata)) {
        _this.setMetadata(metadata);
      }

      return _this;
    }

    _createClass(utMetadata, [{
      key: "onHandshake",
      value: function onHandshake(infoHash, peerId, extensions) {
        this._infoHash = infoHash;
      }
    }, {
      key: "onExtendedHandshake",
      value: function onExtendedHandshake(handshake) {
        if (!handshake.m || !handshake.m.ut_metadata) {
          return this.emit('warning', new Error('Peer does not support ut_metadata'));
        }

        if (!handshake.metadata_size) {
          return this.emit('warning', new Error('Peer does not have metadata'));
        }

        if (typeof handshake.metadata_size !== 'number' || MAX_METADATA_SIZE < handshake.metadata_size || handshake.metadata_size <= 0) {
          return this.emit('warning', new Error('Peer gave invalid metadata size'));
        }

        this._metadataSize = handshake.metadata_size;
        this._numPieces = Math.ceil(this._metadataSize / PIECE_LENGTH);
        this._remainingRejects = this._numPieces * 2;

        this._requestPieces();
      }
    }, {
      key: "onMessage",
      value: function onMessage(buf) {
        var dict;
        var trailer;

        try {
          var str = buf.toString();
          var trailerIndex = str.indexOf('ee') + 2;
          dict = bencode.decode(str.substring(0, trailerIndex));
          trailer = buf.slice(trailerIndex);
        } catch (err) {
          // drop invalid messages
          return;
        }

        switch (dict.msg_type) {
          case 0:
            // ut_metadata request (from peer)
            // example: { 'msg_type': 0, 'piece': 0 }
            this._onRequest(dict.piece);

            break;

          case 1:
            // ut_metadata data (in response to our request)
            // example: { 'msg_type': 1, 'piece': 0, 'total_size': 3425 }
            this._onData(dict.piece, trailer, dict.total_size);

            break;

          case 2:
            // ut_metadata reject (peer doesn't have piece we requested)
            // { 'msg_type': 2, 'piece': 0 }
            this._onReject(dict.piece);

            break;
        }
      }
      /**
       * Ask the peer to send metadata.
       * @public
       */

    }, {
      key: "fetch",
      value: function fetch() {
        if (this._metadataComplete) {
          return;
        }

        this._fetching = true;

        if (this._metadataSize) {
          this._requestPieces();
        }
      }
      /**
       * Stop asking the peer to send metadata.
       * @public
       */

    }, {
      key: "cancel",
      value: function cancel() {
        this._fetching = false;
      }
    }, {
      key: "setMetadata",
      value: function setMetadata(metadata) {
        if (this._metadataComplete) return true;
        debug('set metadata'); // if full torrent dictionary was passed in, pull out just `info` key

        try {
          var info = bencode.decode(metadata).info;

          if (info) {
            metadata = bencode.encode(info);
          }
        } catch (err) {} // check hash


        if (this._infoHash && this._infoHash !== sha1.sync(metadata)) {
          return false;
        }

        this.cancel();
        this.metadata = metadata;
        this._metadataComplete = true;
        this._metadataSize = this.metadata.length;
        this._wire.extendedHandshake.metadata_size = this._metadataSize;
        this.emit('metadata', bencode.encode({
          info: bencode.decode(this.metadata)
        }));
        return true;
      }
    }, {
      key: "_send",
      value: function _send(dict, trailer) {
        var buf = bencode.encode(dict);

        if (Buffer.isBuffer(trailer)) {
          buf = Buffer.concat([buf, trailer]);
        }

        this._wire.extended('ut_metadata', buf);
      }
    }, {
      key: "_request",
      value: function _request(piece) {
        this._send({
          msg_type: 0,
          piece: piece
        });
      }
    }, {
      key: "_data",
      value: function _data(piece, buf, totalSize) {
        var msg = {
          msg_type: 1,
          piece: piece
        };

        if (typeof totalSize === 'number') {
          msg.total_size = totalSize;
        }

        this._send(msg, buf);
      }
    }, {
      key: "_reject",
      value: function _reject(piece) {
        this._send({
          msg_type: 2,
          piece: piece
        });
      }
    }, {
      key: "_onRequest",
      value: function _onRequest(piece) {
        if (!this._metadataComplete) {
          this._reject(piece);

          return;
        }

        var start = piece * PIECE_LENGTH;
        var end = start + PIECE_LENGTH;

        if (end > this._metadataSize) {
          end = this._metadataSize;
        }

        var buf = this.metadata.slice(start, end);

        this._data(piece, buf, this._metadataSize);
      }
    }, {
      key: "_onData",
      value: function _onData(piece, buf, totalSize) {
        if (buf.length > PIECE_LENGTH || !this._fetching) {
          return;
        }

        buf.copy(this.metadata, piece * PIECE_LENGTH);

        this._bitfield.set(piece);

        this._checkDone();
      }
    }, {
      key: "_onReject",
      value: function _onReject(piece) {
        if (this._remainingRejects > 0 && this._fetching) {
          // If we haven't been rejected too much,
          // then try to request the piece again
          this._request(piece);

          this._remainingRejects -= 1;
        } else {
          this.emit('warning', new Error('Peer sent "reject" too much'));
        }
      }
    }, {
      key: "_requestPieces",
      value: function _requestPieces() {
        if (!this._fetching) return;
        this.metadata = Buffer.alloc(this._metadataSize);

        for (var piece = 0; piece < this._numPieces; piece++) {
          this._request(piece);
        }
      }
    }, {
      key: "_checkDone",
      value: function _checkDone() {
        var done = true;

        for (var piece = 0; piece < this._numPieces; piece++) {
          if (!this._bitfield.get(piece)) {
            done = false;
            break;
          }
        }

        if (!done) return; // attempt to set metadata -- may fail sha1 check

        var success = this.setMetadata(this.metadata);

        if (!success) {
          this._failedMetadata();
        }
      }
    }, {
      key: "_failedMetadata",
      value: function _failedMetadata() {
        // reset bitfield & try again
        this._bitfield = new BitField(0, {
          grow: BITFIELD_GROW
        });
        this._remainingRejects -= this._numPieces;

        if (this._remainingRejects > 0) {
          this._requestPieces();
        } else {
          this.emit('warning', new Error('Peer sent invalid metadata'));
        }
      }
    }]);

    return utMetadata;
  }(EventEmitter); // Name of the bittorrent-protocol extension


  utMetadata.prototype.name = 'ut_metadata';
  return utMetadata;
};